<template>
    <div>
        <el-dialog
            title="用户余额退款"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-form ref="form" :model="form" label-position='left' label-width='100px' :rules='rules'>
                    <el-form-item label="退款金额" prop='refundAmount'>
                        <div class="a-flex-cfsfs">
                            <jd-input-price v-model="form.refundAmount" style="width:400px"></jd-input-price>
                            <div class="a-flex-rfsc infoBox a-mt-10">
                                <i class="el-icon-warning a-c-error"></i>
                                <span class="a-ml-5">用户余额：￥{{ util.numFormat(userBalanceInfo.total || 0) }}</span>
                                <span class="a-ml-40">超期余额（充值超过1年）：￥{{ util.numFormat(userBalanceInfo.notRefund || 0) }}</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="退款原因" prop='refundMsg'>
                        <el-input
                            type="textarea"
                            :rows="4"
                            maxlength="80"
                            class="inputBox"
                            placeholder="请输入内容"
                            v-model="form.refundMsg">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            var checkAmount = (rule, value, callback) => {
                if(!this.form.refundAmount){
                    callback(new Error('请输入退款金额'))
                } else if(this.form.refundAmount <= 0 || this.form.refundAmount === '0'){
                    callback(new Error('退款金额必须大于0'))
                } else if((this.form.refundAmount*100).toFixed(0) > this.userBalanceInfo.total){
                    callback(new Error('退款金额不得超过用户余额'))
                } else{
                    callback()
                }
            };
            return {
                util,
                dialogVisible: false,
                userId: '',
                userBalanceInfo: {},
                form: {
                    refundAmount: '',
                    refundMsg: '',
                },
                rules: {
                    refundAmount: [{ validator: checkAmount, trigger: 'blur' }],
                    refundMsg: [{required: true, message:'请输入退款原因', trigger: 'blur'}]
                }
            };
        },
        watch:{
            dialogVisible (val) {
                if(!val) {
                    this.$refs['form'].resetFields()
                }
            }
        },
        mounted () {

        },
        methods:{
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let reqData = {
                            "balanceId": this.userId,
                            "payType": 0,
                            "refundAmount": this.form.refundAmount ? Number((this.form.refundAmount * 100).toFixed(0)) : '',
                            "refundMsg": this.form.refundMsg,
                            "userId": this.userId
                        }

                        let tipsContent = '是否确认退款？'
                        if(reqData.refundAmount > this.userBalanceInfo.total - this.userBalanceInfo.notRefund) {
                            tipsContent = '该用户存在充值超过1年的余额，无法线上直接退款，请向用户线下转账。本次退款多少，就转多少（注意不是仅转超期余额）'
                        }
                        this.$confirm(tipsContent, '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_ => {
                            this.$Axios._post({
                                url: this.$Config.apiUrl.rechargeRefund,
                                params: {
                                    ...reqData
                                }
                            }).then(({data}) => {
                                this.dialogVisible = false
                                this.$emit('success')
                                this.$message.success('操作成功')
                            }).catch((error) => {
                                
                            })
                        }).catch(_ => { })


                        
                    }
                })
            },
            getUserBalance () { 
                this.$Axios._post({
                    url: this.$Config.apiUrl.userBalance,
                    params: {
                        "balanceId": this.userId,
                        "userId": this.userId,
                        "payType": 0
                    }
                }).then(({data}) => {
                    this.userBalanceInfo = data
                }).catch((error) => {
                    
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .infoBox{
        color: #333333;
        font-size: 14px;
        background: #FEFBF6;
        border-radius: 8px;
        padding: 0 10px;
        line-height: 40px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .a-mr-10{
        margin-right: 10px;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>